import "../../styles/dash/SideBar.css";
import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import navIMG from "../../assets/app/Nav/LOGO-FONDO-NEGRO.png";

interface SideBarProps {
  name: string;
  email: string;
}

interface props {
  name: string;
  email: string;
  permisos: number[];
}

const SideBar: React.FC<props> = ({ name, email, permisos }) => {

  const [configOpen, setConfigOpen] = useState(false);
  const location = useLocation();
  const basePath = "/dashboard";

  // Determinar si la sección de configuración debe estar abierta
  useEffect(() => {
    const isConfigRoute = location.pathname.startsWith(`${basePath}/users`) ||
      location.pathname.startsWith(`${basePath}/roles`);
    setConfigOpen(isConfigRoute);
  }, [location.pathname]);

  const toggleConfig = () => {
    setConfigOpen(!configOpen);
  };

  // Verificar si estamos en una ruta de configuración
  const isConfigActive = location.pathname.startsWith(`${basePath}/users`) ||
    location.pathname.startsWith(`${basePath}/roles`);

  // Constantes para verificar permisos
  const canViewUsers = permisos.includes(12);
  const canViewRoles = permisos.includes(18);
  const showConfigSection = canViewUsers || canViewRoles;

  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img
            src={navIMG}
            alt="Logo"
            className="sidebar-logo-img"
            loading="eager"
          />
        </div>
        <div className="sidebar-user-info">
          <p className="sidebar-user-name">{name}</p>
          <p className="sidebar-user-email">{email}</p>
        </div>
      </div>

      <div className="sidebar-section">
        {permisos.includes(7) && (
          <NavLink
            to={`${basePath}/bots`}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </span>
            <span>ChatsBots</span>
          </NavLink>
        )}

        {permisos.includes(32) && (
          <NavLink
            to={`${basePath}/demo-request`}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
              </svg>
            </span>
            <span>Demo Request</span>
          </NavLink>
        )}

        {permisos.includes(23) && (
          <NavLink
            to={`${basePath}/clients`}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }>
            <span className="sidebar-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </span>
            <span>Clientes</span>
          </NavLink>
        )}

        {permisos.includes(28) && (
          <NavLink
            to={`${basePath}/blogs`}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
              </svg>
            </span>
            <span>Blogs</span>
          </NavLink>
        )}

        {showConfigSection && (
          <>
            <button
              className={`sidebar-item ${isConfigActive ? 'active' : ''}`}
              onClick={toggleConfig}
            >
              <span className="sidebar-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="3" />
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
              </span>
              <span>Configuración</span>

              {/* Flecha indicadora */}
              <span className={`config-arrow ${configOpen ? 'open' : ''}`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </button>

            {configOpen && (
              <div className="sidebar-subsection">
                {canViewUsers && (
                  <NavLink
                    to={`${basePath}/users`}
                    className={({ isActive }) =>
                      `sidebar-item sub-item ${isActive ? 'active' : ''}`
                    }>

                    <span className="sidebar-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-3-3.87M4 21v-2a4 4 0 0 1 3-3.87M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" />
                      </svg>
                    </span>
                    <span>Usuarios</span>

                    <span className="subitem-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                    </span>
                  </NavLink>
                )}

                {canViewRoles && (
                  <NavLink
                    to={`${basePath}/roles`}
                    className={({ isActive }) =>
                      `sidebar-item sub-item ${isActive ? 'active' : ''}`
                    }
                  >
                    <span className="sidebar-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                    </span>
                    <span>Roles</span>

                    <span className="subitem-arrow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6" />
                      </svg>
                    </span>
                  </NavLink>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SideBar;